import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Citta } from "../../types"
import CittaForm from "./CittaForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesCitta, validationSchemaCitta } from "./CittaCommon"
import { useMemo } from "react"

export default function CittaModal({
  title,
  citta,
  save,
  show,
  onClose,
}: {
  title: string
  citta?: Citta
  save: (values: Citta) => Promise<void>
  show: boolean
  onClose: () => void
}) {
  const initalValues = useMemo(() => initialValuesCitta(citta) as Citta, [citta])
  const validationSchema = useMemo(() => validationSchemaCitta(), [])

  return (
    <Formik enableReinitialize initialValues={initalValues} validationSchema={validationSchema} onSubmit={save}>
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static" onBackdropClick={onClose}>
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <CittaForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
